import { injectable } from 'tsyringe';
import { OWExtensionsDelegate, OWExtensionsListener } from '../../odk-ts';
import { DelegateProvider } from '../../shared/interfaces/delegate-provider.interface';

// -----------------------------------------------------------------------------
// Testable wrapper for OWExtension
@injectable()
export class OWExtensionsListenerWrapper
  implements DelegateProvider<OWExtensionsDelegate>
{
  private readonly listeners: Map<OWExtensionsDelegate, OWExtensionsListener>;

  // ---------------------------------------------------------------------------
  public constructor() {
    this.listeners = new Map<OWExtensionsDelegate, OWExtensionsListener>();
  }

  // ---------------------------------------------------------------------------
  // DelegateProvider
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  addListener(listener: OWExtensionsDelegate) {
    // Make sure we clear callbacks, in case we already have this listener
    this.removeListener(listener);
    this.listeners.set(listener, new OWExtensionsListener(listener, true));
  }

  // ---------------------------------------------------------------------------
  removeListener(listener: OWExtensionsDelegate) {
    const extensionsListener = this.listeners.get(listener);
    if (!extensionsListener) {
      return;
    }

    extensionsListener.stop();
    this.listeners.delete(listener);
  }
}
